import { IntegrationService } from '../../../../../../services/exports/Constants';

export default {
  title: 'Integrationer',
  services: {
    [IntegrationService.Tabless]: 'Tabless',
    [IntegrationService.WinOrder]: 'WinOrder',
    [IntegrationService.ExpertOrder]: 'ExpertOrder',
    [IntegrationService.Deliverect]: 'Deliverect',
    [IntegrationService.Liefersoft]: 'Liefersoft',
    [IntegrationService.Hubrise]: 'HubRise',
  },
  labels: {
    no_integrations: '{{company}} har ingen konfigurerede integrationer.',
  },
  buttons: {
    add_integration: 'Tilføj integration',
  },
  toasts: {
    error: 'Ændringerne kunne ikke gemmes',
    success: 'Ændringerne er gemt',
    load_error: 'Integrationerne kunne ikke indlæses',
  },
};
